import { render } from "./ForwardModal.vue?vue&type=template&id=74489950&scoped=true"
import script from "./ForwardModal.vue?vue&type=script&lang=js"
export * from "./ForwardModal.vue?vue&type=script&lang=js"

import "./ForwardModal.vue?vue&type=style&index=0&id=74489950&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74489950"]])

export default __exports__